/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { TextInput, type TextInputProps } from 'react-native';
import {
  numericTextInputDefaults,
  sanitizeNumericInputText,
} from '../../shared/numeric/public-api';

/**
 * Monto de gasto: mismo saneado que NumericTextInput(kind="decimalMoney") pero
 * observa el texto CRUDO antes de sanear. El sanitizador descarta el "-" en
 * silencio ("-50" queda "50") — el padre muestra un aviso vía onNegativeAttempt.
 * (audit UX: normalización silenciosa de negativos).
 */
export type ExpenseAmountInputProps = Omit<TextInputProps, 'onChangeText'> & {
  value: string;
  onChangeText: (text: string) => void;
  /** Se llama cuando el texto crudo incluye "-" (antes de sanearlo). */
  onNegativeAttempt?: () => void;
};

export function ExpenseAmountInput({
  value,
  onChangeText,
  onNegativeAttempt,
  ...rest
}: ExpenseAmountInputProps) {
  return (
    <TextInput
      {...numericTextInputDefaults('decimalMoney')}
      {...rest}
      value={value}
      onChangeText={(raw) => {
        if (raw.includes('-')) onNegativeAttempt?.();
        onChangeText(sanitizeNumericInputText(raw, 'decimalMoney'));
      }}
    />
  );
}
